import Vue from 'vue';
import VueRouter, { RouteConfig } from 'vue-router';
import Setup from '../views/setup/Setup.vue';
import users from '@/store/modules/users';

Vue.use(VueRouter);

const routes: RouteConfig[] = [
  {
    path: '/home',
    name: 'setup',
    component: Setup,
  },
  {
    path: '/home/:id',
    name: 'edit_client',
    component: Setup,
  },
  {
    path: '/auth',
    name: 'login',
    // route level code-splitting
    // this generates a separate chunk (about.[hash].js) for this route
    // which is lazy-loaded when the route is visited.
    component: () => import('../views/login/Auth.vue'),
  },
  {
    path: '/register',
    name: 'register',
    component: () => import('../views/register/Register.vue'),
  },
  {
    path: '/summary',
    name: 'summary',
    component: () => import('../views/summary/Summary.vue'),
  },
  {
    path: '/reports',
    name: 'reports',
    component: () => import('../views/reports/Reports.vue'),
  },
  {
    path: '/billing',
    name: 'billing',
    component: () => import('../views/billing/Billing.vue'),
    props: true,
  },
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach(async (to, from, next) => {
  try {
    if (!users.isAuthenticated && to.name !== 'login') {
      next('/auth');
    } else {
      next();
    }
  } catch (error) {
    return error;
  }
});

export default router;
